// services/useUpdateResponsavelSingle.ts
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import api from '@/lib/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'

type UpdateRespSingleParams = {
  id_client: string
  id_responsavel: string
}

// opcional: padronize chaves
export const productKeys = {
  all: ['product'] as const,
  byId: (id?: string) => ['product', id] as const
}

export function useUpdateResponsavelSingle() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ id_client, id_responsavel }: UpdateRespSingleParams) => {
      if (!user || !token) throw new Error('Usuário não autenticado')
      const res = await api.patch(
        `/clients/${id_client}/responsavel`,
        { id_responsavel },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      if (!res.data) throw new Error('Erro ao atualizar responsável (single)')
      return res.data
    },
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['clients'] })
      queryClient.invalidateQueries({ queryKey: ['client', vars.id_client] })
      queryClient.invalidateQueries({ queryKey: ['product'] })
      queryClient.invalidateQueries({ queryKey: ['product', vars.id_client] })

      // força o refetch agora (não espera foco/fetch automático)
      queryClient.refetchQueries({ queryKey: ['product', vars.id_client] })
    }
  })
}
